const adminOnlyStatuses = [
  'ReviewPending',
  'MonthInProgress',
  'ReviewCompleted',
  'MonthSkipped'
]

export const getFilteredInvoices = (
  invoices,
  searchValue,
  showSkippedInvoices,
  isInternalAdmin,
  paymentAmountInProgress
) => {
  if (invoices) {
    const filteredInvoices = invoices
      .filter(invoice =>
        `${invoice.searchString} #${invoice.subsidiaryInvoiceId}`.match(
          new RegExp(searchValue, 'i')
        )
      )
      .filter(invoice => (invoice.status === 'MonthSkipped' ? showSkippedInvoices : true))
      .filter(invoice =>
        isInternalAdmin ? true : !adminOnlyStatuses.includes(invoice.status)
      )
      .map(invoice => ({ ...invoice, isPaymentInProgress: false }))

    let remainingPaymentInProgress = paymentAmountInProgress

    const invoiceIdsOfPendingPayments = filteredInvoices
      .slice()
      .reverse()
      .filter(invoice => ['PaidPartially', 'PaymentPending'].includes(invoice.status))
      .map(i => i.subsidiaryInvoiceId)

    invoiceIdsOfPendingPayments?.forEach(invoiceId => {
      if (remainingPaymentInProgress > 0) {
        const invoice = filteredInvoices.find(i => i.subsidiaryInvoiceId === invoiceId)

        remainingPaymentInProgress =
          remainingPaymentInProgress - invoice.totalAmountDueRemaining

        invoice.isPaymentInProgress = true
      }
    })

    return filteredInvoices.sort(
      (a, b) => new Date(b.generatedOn) - new Date(a.generatedOn)
    )
  }
  return []
}
